import React from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Badge,
} from "reactstrap";
import { Icon } from "../../../components/Component"; // Adjust path as needed
import { getPublicDocumentUrl, imageUrlRegex, pdfUrlRegex } from "../../../utils/envConfig"; // Assuming these are in envConfig

const ChannelPartnerDetailModal = ({ isOpen, toggle, partner }) => {
    if (!partner) {
        return null;
    }

    const renderDocumentPreview = () => {
        if (!partner.document) {
            return <p>No document uploaded.</p>;
        }

        const documentUrl = getPublicDocumentUrl(partner.document);
        const isImage = imageUrlRegex.test(partner.document.toLowerCase());
        const isPdf = pdfUrlRegex.test(partner.document.toLowerCase());
        const fileName = partner.document.split('/').pop();

        let iconName = "file-text"; // Default icon
        if (isImage) iconName = "img";
        else if (isPdf) iconName = "file-pdf";
        // Add more else if for other common types like doc, zip etc.
        // else if (partner.document.toLowerCase().endsWith('.doc') || partner.document.toLowerCase().endsWith('.docx')) iconName = "file-docs";
        // else if (partner.document.toLowerCase().endsWith('.zip')) iconName = "file-zip";


        return (
            <div>
                <h6>Document: {partner.documentType || "N/A"}</h6>
                {isImage ? (
                    <a href={documentUrl} target="_blank" rel="noopener noreferrer" title={`View ${fileName}`}>
                        <img src={documentUrl} alt={fileName} style={{ maxWidth: "100%", maxHeight: "200px", border: "1px solid #ddd" }} />
                    </a>
                ) : (
                    <a href={documentUrl} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center" title={`Download ${fileName}`}>
                        <Icon name={iconName} style={{ fontSize: "2rem", marginRight: "10px" }} />
                        <span>{fileName}</span>
                    </a>
                )}
            </div>
        );
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>
                Channel Partner Details: {partner.name}
            </ModalHeader>
            <ModalBody>
                <p>
                    <strong>Name:</strong> {partner.name}
                </p>
                <p>
                    <strong>Type:</strong> {partner.type}
                </p>
                <p>
                    <strong>Manager Name:</strong> {partner.managerName || "N/A"}
                </p>
                <p>
                    <strong>Website:</strong>{" "}
                    {partner.website ? (
                        <a href={partner.website} target="_blank" rel="noopener noreferrer">
                            {partner.website}
                        </a>
                    ) : (
                        "N/A"
                    )}
                </p>
                <p>
                    <strong>Manager Contact:</strong> {partner.managerContact || "N/A"}
                </p>
                <p>
                    <strong>Status:</strong>{" "}
                    <Badge color={partner.active ? "success" : "danger"}>
                        {partner.active ? "Active" : "Inactive"}
                    </Badge>
                </p>
                <hr />
                {renderDocumentPreview()}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ChannelPartnerDetailModal;